export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-thumbnail-v1-960-3c00969edf560d74e79f85b5cba8c53a.webp";